export default {
  somethingWentWrong: {
    id: 'personalized_feed_error_state_title',
    defaultMessage: 'Oops! Something went wrong',
  },
  maybeThereIsAProblemWithYourConnection: {
    id: 'personalized_feed_error_state_message',
    defaultMessage: "Maybe there's a problem with your connection?",
  },
  tryAgain: {
    id: 'personalized_feed_error_state_try_again',
    defaultMessage: 'Try again',
  },
} as const
